import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserModePreference = 'operator' | 'supervisor';

interface UserModeState {
  modePreference: UserModePreference;
  setModePreference: (mode: UserModePreference) => void;
  toggleModePreference: () => void;
}

export const useUserMode = create<UserModeState>()(
  persist(
    (set) => ({
      modePreference: 'operator',
      setModePreference: (mode) => set({ modePreference: mode }),
      toggleModePreference: () => set((state) => ({
        modePreference: state.modePreference === 'operator' ? 'supervisor' : 'operator',
      })),
    }),
    {
      name: 'user-mode-storage',
    }
  )
);
